// Route wording changes through design review, not ad-hoc edits.
const InputDisclaimer = () => (
  <p className='px-4 py-1 text-center text-sm font-medium text-gx-subtext'>
    GX Go Assistant is an AI. Indexes shown are GX-published, not AI-generated. Explanations may
    contain errors. Please verify.
  </p>
);

export default InputDisclaimer;
